module.exports = __webpack_public_path__ + "img/per-ride.4ea05fd5.svg";